import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Common Components
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import ScrollToTop from './helper/ScrollToTop';

// Import All Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Product from "./pages/Product";
import Contact from "./pages/Contact";

function AppContent() {
    return (
        <>
            <ScrollToTop />
            <Header />
            <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/product" element={<Product />} />
                <Route path="/contact" element={<Contact />} />
            </Routes>
            <Footer />
        </>
    );
}

export default function App() {
    return (
        <BrowserRouter basename="/">
            <AppContent />
        </BrowserRouter>
    );
}